import { render, staticRenderFns } from "./ContractPremiumReminderList.vue?vue&type=template&id=0e19f41b"
import script from "./ContractPremiumReminderList.vue?vue&type=script&lang=js"
export * from "./ContractPremiumReminderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports